module.exports = __webpack_public_path__ + "img/button-swag.443c9656.svg";